import { PushGADataLayer } from "../../utils/helpers";
import BaseButton from "../BaseButton";
import BaseContainer from "../BaseContainer";
import NavigationPanelItem from "./NavigationPanelItem";

const getThreeColumnNav = (navigation) => {
  const navLength =  navigation.length;
  const isRemainingNav = ((navLength/3 )>0) ? navLength%3 : 0 ;
  const navItemsLength = {
    first : Math.floor(navLength/3) + ((isRemainingNav>0)? 1: 0),
    second :  Math.floor(navLength/3) + ((isRemainingNav>1)? 1: 0),
    third :  Math.floor(navLength/3)
  };

  const navFromIndices = {
    first : navItemsLength.first,
    second : navItemsLength.first+navItemsLength.second,
    third : navItemsLength.first+navItemsLength.second + navItemsLength.third
  };

  return (
    <>
    <div className="justify-start items-start gap-10 col-span-1">
        <div className="flex-col justify-start items-start gap-8 flex">
        {navItemsLength.first? (navigation.slice(0, navFromIndices.first).map((navItem,key)=><NavigationPanelItem key={`nav-col-1-${key}`} navItem={navItem}/>)):null}
        </div>
    </div>
    <div className="justify-start items-start gap-10 col-span-1">
        <div className="flex-col justify-start items-start gap-8 flex">
        {navItemsLength.second? (navigation.slice(navFromIndices.first, (navFromIndices.second)).map((navItem,key)=><NavigationPanelItem key={`nav-col-2-${key}`} navItem={navItem}/>)):null}
        </div>
    </div>
    <div className="justify-start items-start gap-10 col-span-1">
        <div className="flex-col justify-start items-start gap-8 flex">
        {navItemsLength.third? (navigation.slice(navFromIndices.second, navFromIndices.third).map((navItem,key)=><NavigationPanelItem key={`nav-col-3-${key}`} navItem={navItem}/>)):null}
        </div>
    </div>
    </>
  )

}

const NavigationPanel =({navigation, overViewData, ctaAction}) => {


    return (
      <BaseContainer>
      <div className='relative pt-16 pb-10  flex-col justify-start items-start gap-8 overflow-y-auto'>
        <div className='grid grid-cols-4 columns-4 content-evenly gap-x-5'>
          {
            getThreeColumnNav(navigation)
          }
          <div className="justify-start items-start gap-10 col-span-1">
            <div className="flex-col justify-start items-start gap-4 flex">
              <div className="text-black text-base xl:text-lg font-bold mx-4">{ctaAction.sideNavigationTitle}</div>
                <div className="justify-start">
                  {
                    ctaAction.sideNavigations.map((sideNav,key)=> {
                      return(<div key={`side-${key}`} className="items-start flex gap-6 py-2">
                        <BaseButton classes={`bg-transparent uppercase lg:text-sm font-bold items-start`} iconClassName="w-5 h-5" type="tertiary" size="small" title={sideNav.sideNavigationChildTitle} href={sideNav.sideNavigationChildURL} target={sideNav.sideNavigationChildTarget} icon={(sideNav.sideNavigationChildTarget)?'external-link':null} btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',sideNav.sideNavigationChildTitle)}}/>
                      </div>)
                    })
                  }
              </div>
            </div>
            <div className="justify-start items-start">
              <div className="pl-5">
                <div className="pt-1 pb-0.5 justify-center items-center">
                {
                  <div className="pt-1 pb-0.5 justify-center items-start">
                    <BaseButton type='primary' classes='font-bold mt-4 w-full lg:h-[50px] lg:text-base' iconClassName="ml-1.5 -mt-0.5 w-5" title={ctaAction.sideNavigationsCTA[0].sideNavigationChildTitle} href={ctaAction.sideNavigationsCTA[0].sideNavigationChildURL} target='_blank' icon={ctaAction.sideNavigationsCTA[0].sideNavigationChildIcon} btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',ctaAction.sideNavigationsCTA[0].sideNavigationChildTitle)}}/>
                    <BaseButton type='secondary' classes='font-bold mt-4 w-full lg:h-[50px] lg:text-base' iconClassName="ml-1.5 -mt-0.5 w-5" title={ctaAction.sideNavigationsCTA[1].sideNavigationChildTitle} href={ctaAction.sideNavigationsCTA[1].sideNavigationChildURL} target='_blank' icon={ctaAction.sideNavigationsCTA[1].sideNavigationChildIcon} btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',ctaAction.sideNavigationsCTA[1].sideNavigationChildTitle)}}/>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="justify-start items-start gap-10 col-span-1">
          { 
            overViewData.href &&
            <div className="pt-8 -ml-7">
              <BaseButton type='tertiary' size='none' classes='px-7 pt-0.5 pb-0 text-ek-red text-base font-bold uppercase' title={overViewData.title} href={overViewData.href} target={overViewData.target} icon='arrow-right' btnClick={()=>{PushGADataLayer('Navigations','Top Navigation',overViewData.overviewTitle)}}/>
            </div>
          }
          </div>
          <div className="absolute left-3/4 top-0 h-full border-l-ek-grey-300 border-l-2"></div>
        </div>
    </div>
    </BaseContainer>
    )
}

export default NavigationPanel;